import { useMemo } from "react";
import AddPageSubMenu from "src/components/layouts/AddPageSubMenu";
import { createItemSettingsSubMenu } from "src/routing/navigation";

const ItemSettingsSubMenu: React.FC = () => {
    const subMenu = useMemo(() => {
        return createItemSettingsSubMenu();
    }, []);

    if (!subMenu) {
        return null;
    }

    return <AddPageSubMenu subMenu={subMenu} />;
};

export default ItemSettingsSubMenu;
